import angular from 'angular';
import moment from "angular-moment";

import chartConfig from './weather-correlation-graph.config';

export class WeatherCorrelationGraphController {
  /*@ngInject*/
  constructor($scope, $filter, moment) {
    this.$filter = $filter;

    this.chartConfig = chartConfig(this);

    $scope.$watch('$ctrl.data.dailyActivePower', newValue => this.updateGraph(newValue));
  }

  $onInit() {}

  updateGraph(dailyActivePowerData) {
    if (!dailyActivePowerData || !this.chart) {
      return;
    }

    const dailyActivePower = dailyActivePowerData.current;
    const dailyWeather = dailyActivePowerData.currentWeather;
    const [categories, graphData] = this.createGraphData(dailyActivePower, dailyWeather);

    this.chart.xAxis[0].setCategories(categories);
    this.chart.series[0].setData(graphData);
    this.chart.reflow();
  }

  createGraphData(dailyPowers, weathers) {
    if (dailyPowers.length === 0) {
      return [];
    }

    const avgs = {};
    for (let weather of weathers) {
      if (!weather.icon_id) {
        continue;
      }
      let iconId = weather.icon_id.replace().slice(0, 2);
      if (!iconId) {
        continue;
      }

      if (iconId === '04') {
        iconId = '03';
      }
      if (!avgs[iconId]) {
        avgs[iconId] = {count: 0, sum: 0}
      }

      const powers = dailyPowers.filter(e => e.date === weather.date);
      for (let power of powers) {
        avgs[iconId].count += 1;
        avgs[iconId].sum += power.value;
      }
    }
    const categories = [];
    const graphData = [];
    for (let key of Object.keys(avgs)) {
      if (avgs[key].count === 0) {
        continue
      }
      categories.push(key);
      const avg = avgs[key].sum / avgs[key].count;
      graphData.push(parseFloat(this.$filter('number')(avg, 2).replace(/,/g, '')));
    }

    return [categories, graphData];
  }
}

export default angular.module('leptonApp.weatherCorrelationGraph', [moment])
  .component('weatherCorrelationGraph', {
    template: '<chart value="$ctrl.chartConfig"></chart>',
    controller: WeatherCorrelationGraphController,
    bindings: {
      data: '='
    }
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/statistics_report/weather-stat-graph/weather-correlation-graph/weather-correlation-graph.component.js